var render = function render(){var _vm=this,_c=_vm._self._c;return _c('trax-ui-ajax-form-hub',{attrs:{"id":"trax-account-user-edit","endpoint":_vm.endpoint,"resource-id":_vm.userid,"props":_vm.props,"forget":_vm.forget,"bus":_vm.bus,"toastr-passed-label":1}})
}
var staticRenderFns = []

export { render, staticRenderFns }